module.exports = __webpack_public_path__ + "img/c16.6424a4aa.png";